<template>
  <div>
    <div class="row mb-2">
      <div class="col-auto mr-auto">
        <h3>{{ currentCategory.name }}</h3>
      </div>
      <div class="col-auto">
        <v-icon
          name="regular/edit"
          class="actions-icon mr-2"
          :title="$t('buttons.edit')"
          @click="editCategory"
        />
        <v-icon
          name="regular/trash-alt"
          class="actions-icon"
          :title="$t('buttons.delete')"
          @click="deleteCategory"
        />
      </div>
    </div>

    <transition-group mode="out-in" name="move" tag="div" class="row">
      <FoodCard
        v-for="(foodItem, id) in filteredFood"
        :key="foodItem.created"
        :id="id"
        :foodItem="foodItem"
      ></FoodCard>
      <NewItemCard
        :route="{
          name: ROUTE_NEW_FOOD,
          params: { preselectCategories: [$route.params.id] }
        }"
        key="new"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "vue-awesome/icons/regular/edit";
import "vue-awesome/icons/regular/trash-alt";
import {
  ROUTE_CATEGORIES,
  ROUTE_CATEGORY_EDIT,
  ROUTE_NEW_FOOD
} from "../../constants";
import FoodCard from "./../food/FoodCard";
import NewItemCard from "./../NewItemCard";

export default {
  name: "CategoryDetail",
  components: { FoodCard, NewItemCard },
  data() {
    return {
      ROUTE_CATEGORY_EDIT,
      ROUTE_NEW_FOOD
    };
  },
  computed: {
    ...mapGetters(["pantryAuthData", "categoryById", "foodInCategory"]),
    currentCategory() {
      return this.categoryById(this.$route.params.id);
    },
    filteredFood() {
      return this.foodInCategory(this.$route.params.id);
    }
  },
  methods: {
    editCategory() {
      this.$router.push({
        name: this.ROUTE_CATEGORY_EDIT,
        params: { id: this.$route.params.id, name: this.currentCategory.name }
      });
    },
    removeFromAllFood() {
      // loop through all items in this category
      for (const [foodKey, foodItem] of Object.entries(this.filteredFood)) {
        for (const key in foodItem.categories) {
          // remove this category from the item
          if (foodItem.categories[key] === this.$route.params.id) {
            foodItem.categories.splice(key, 1);
          }
        }
        // save it!
        foodItem.updated = new Date().getTime();
        // TODO: show loading?
        this.$store.state.resources.food
          .update(
            {
              ...this.pantryAuthData,
              id: foodKey
            },
            foodItem
          )
          .then(
            response => {
              // this.$emit("foodSubmitted", {
              //   id: foodKey,
              //   foodItem: foodItem
              // });
              console.log(
                this.currentCategory.name +
                  " deleted from " +
                  response.body.name
              );
            },
            error => {
              console.log(error);
            }
          );
      }
    },
    deleteCategory() {
      if (
        confirm(
          this.$t("categories.deleteConfirm", [this.currentCategory.name])
        )
      ) {
        // TODO: show loading?
        // remove from food
        this.removeFromAllFood();
        // actually delete category
        this.$store.state.resources.categories
          .delete({
            ...this.pantryAuthData,
            id: this.$route.params.id
          })
          .then(
            () => {
              console.log("deleted on remote: " + this.$route.params.id);
              this.$router.push({
                name: ROUTE_CATEGORIES,
                params: { forceReload: true }
              });
            },
            error => {
              console.log(error);
            }
          );
      } else {
        console.log("deletion cancelled");
      }
    }
  }
};
</script>

<style scoped></style>
